<template>
    <QualificationField
        :title="$t('profile.vetting.qualification.industry.expertise.title')"
        :field-author-and-date="qualification.commentOnIndustryExpertise"
        data-testid="admin-section-tabs-qualification-comment-on-industry-expertise"
    >
        <VJoyTextarea
            v-if="profileQualificationStore.inEditMode"
            v-model="profileQualificationStore.qualificationUpdateForm.commentOnIndustryExpertise"
            :placeholder="$t('profile.vetting.qualification.industry.expertise.comment.placeholder')"
            autogrow
            data-testid="vetting-industry-expertise-comment-edition"
        />
        <TextField
            v-else
            truncate
            :content="profileQualificationStore.qualificationUpdateForm.commentOnIndustryExpertise"
            :replace-by="$t('profile.vetting.qualification.industry.expertise.comment.empty.placeholder')"
            data-testid="vetting-industry-expertise-comment"
        />
    </QualificationField>

    <QualificationField
        v-if="isListVisible && freelancerVerticalStore.isStrategyPendingOrAccepted"
        :title="$t('profile.vetting.qualification.industry.expertise.title.list')"
        data-testid="admin-section-tabs-qualification-industry-skill-ratings"
    >
        <SkillRatingsField
            v-model:skill-ratings="profileQualificationStore.qualificationUpdateForm.industrySkillRatings"
            data-testid="vetting-industry-expertise-ratings-edition"
        />
    </QualificationField>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {storeToRefs} from 'pinia';
    import {VJoyTextarea} from '@maltjoy/core-vue';
    import SkillRatingsField from '~/components/admin-section-tabs/qualification/SkillRatingsField.vue';
    import TextField from '~/components/admin-section-tabs/qualification/TextField.vue';
    import {useFreelancerVerticalStore} from '~/store/freelancerVerticalStore';
    import {useProfileQualificationStore} from '~/store/profileQualificationStore';
    import QualificationField from './ui/QualificationField.vue';

    const freelancerVerticalStore = useFreelancerVerticalStore();
    const profileQualificationStore = useProfileQualificationStore();

    const {qualification} = storeToRefs(profileQualificationStore);

    const isListVisible = computed((): boolean => profileQualificationStore.qualificationUpdateForm.industrySkillRatings.length > 0);
</script>
